<template>
  <div class="pr-2">
    <template
      v-if="db_line_items && db_line_items.length && db_line_items.length > 0"
    >
      <div
        class="d-flex grey lighten-4 px-2"
        style="border-bottom: solid 1px #e4e3e3 !important"
      >
        <div
          class="color-custom-blue py-2 font-weight-600 text-center"
          style="width: 5%"
        >
          <v-checkbox
            v-model="allLineItemsChecked"
            hide-details
            dense
            class="ma-0 pa-0 justify-center"
            @change="toggleAllLineItems"
          />
        </div>
        <div
          class="color-custom-blue py-2 font-weight-600 text-left"
          style="width: 40%"
        >
          Product/Service/Customer Asset
        </div>
        <div
          class="color-custom-blue py-2 font-weight-600 text-center"
          style="width: 20%"
        >
          Selling/Unit Cost
        </div>
        <div
          class="color-custom-blue py-2 font-weight-600 text-center"
          style="width: 20%"
        >
          Quantity/UOM
        </div>

         <div
          class="color-custom-blue py-2 font-weight-600 text-center"
          style="width: 20%"
        >
          Discount
        </div>

        
        <div
          class="color-custom-blue py-2 font-weight-600 text-right"
          style="width: 10%"
        >
          Total
        </div>
      </div>
      <div
        v-for="(row, index) in visibleLineItems"
        class="line-item-drag"
        :key="`line-item-drag-${index}`"
        :class="`${row.class} ${row.type == 'header' ? '' : ''}`"
      >
        <div
          :id="`line-item-drag-${index}`"
          class="d-flex py-1 px-2"
          :class="{ 'item-is-child': row.is_child }"
        >
          <div
            class="font-weight-600 text-center"
            style="width: 5%"
            v-if="row.product_type != 'header'"
          >
            <v-checkbox
              v-model="row.is_checked"
              hide-details
              dense
              class="ma-0 pa-0 justify-center"
              @change="syncHeaderCheckbox"
            />
          </div>
          <div
            class="text-left"
            :style="get_col_style('product', row.is_child)"
          >
            <div class="d-flex align-center">
              <v-avatar size="32" v-if="row.product_type != 'other'">
                <img
                  v-if="row?.image?.url"
                  :src="row?.image?.url"
                  :alt="row?.image?.name"
                />
                <img v-else :src="$defaultImage" />
              </v-avatar>
              <div class="ml-2" style="width: 40%">
                <div class="font-weight-600 font-size-18">
                  {{ row.product }}
                </div>
                <div v-if="row.barcode" class="pt-1">
                  <v-chip
                    label
                    color="chip-custom-blue"
                    outlined
                    small
                    class="text-white p-2 mt-1"
                    style="font-weight: 700"
                  >
                    {{ row.barcode }}
                  </v-chip>
                </div>
              </div>
            </div>
          </div>
          <div
            class="text-center"
            style="width: 20%"
            v-if="!(row.type == 'header')"
          >
            <div class="text-center">
              <v-text-field
                  class="line-item-header-text px-0"
                  placeholder="Selling/Unit Cost"
                  dense
                  filled
                  solo
                  flat
                  type="number"
                  v-model="row.rate"
                  :rules="[validateRules.priceLengthRule]"
                  v-on:keypress="limitDecimal($event, row.rate)"
                  color="cyan"
                />
            </div>
          </div>
          <div
            class="text-center pl-2"
            style="width: 20%"
            v-if="!(row.type == 'header')"
          >
            <div class="text-center d-flex align-center justify-center">
              <v-text-field
                v-model.number="row.quantity"
                type="number"
                hide-details="auto"
                dense
                solo
                flat
                color="cyan"
                class="quantity-input"
                :min="1"
                :max="row.max_quantity"
                :rules="getQuantityRules(row)"
                @input="validateQuantity(row)"
                @change="forceValidateQuantity(row)"
              />
              <span class="ml-1">{{ row.uom }}</span>
            </div>
          </div>
             <div
                v-if="!(row.type == 'header')"
                class="text-center px-2"
                style="width: 20%"
              >
                <div class="d-flex">

                  <v-text-field
                    hide-details
                    class="line-item-header-text px-0"
                    placeholder="Discount"
                    dense
                    filled
                    solo
                    flat
                    type="number"
                    v-on:keypress="limitDecimal($event, row.discount_value)"
                    v-model="row.discount_value"
                    color="cyan"
                    style="width: 50%; min-width: unset"
                  />
                  <v-select
                    :items="discount_type_list"
                    v-model="row.discount_type"
                    hide-details
                    item-text="type"
                    item-value="value"
                    item-color="cyan"
                    class="line-item-header-text discount-type text-h6 px-0"
                    v-on:keypress="limitDecimal($event, row.discount_type)"
                    placeholder="Type"
                    dense
                    filled
                    solo
                    flat
                    color="cyan"
                  />
                </div>
              </div>
          <div
            class="text-center"
            style="width: 10%"
            v-if="!(row.type == 'header')"
          >
            <div class="text-right">{{ getRowTotal(row) }}</div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="d-flex align-center justify-center mt-2">
        <img
          :src="$assetURL('media/error/empty.png')"
          class="row-not-found-image"
        />
        Uhh... There are no line items at the moment.
      </div>
    </template>
    <ViewSerialNumber
      v-if="seleceDialog"
      :transaction-detail="transactionDetail"
      :dialogStatus="seleceDialog"
      v-on:close:dialog="seleceDialog = false"
    >
    </ViewSerialNumber>
    <Dialog :common-dialog="serialNumberDialog">
      <template v-slot:title>
        <div class="d-flex justify-space-between align-center w-100">
          <div class="d-flex align-center">
            <span class="font-weight-medium">Serial Numbers</span>
          </div>

          <v-btn icon small @click="serialNumberDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </template>

      <template v-slot:body>
        <v-container fluid class="px-6">
          <v-card flat outlined class="pa-4">
            <div class="d-flex flex-wrap">
              <v-chip
                v-for="serial in serialNumbers"
                :key="serial.id"
                class="ma-2 font-weight-medium"
                color="cyan darken-2"
                text-color="white"
                label
              >
                {{ serial.text }}
              </v-chip>
            </div>
          </v-card>
        </v-container>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { QUERY } from "@/core/services/store/request.module";
import ViewSerialNumber from "@/view/pages/partials/View-Serial-Number.vue";
import ValidationMixin from "@/core/plugins/validation-mixin";
import Dialog from "@/view/pages/partials/Dialog";
import CommonMixin from "@/core/plugins/common-mixin.js";
export default {
  name: "visit-line-item",
  mixins: [ValidationMixin,CommonMixin],
  props: {
    showPrice: {
      type: Boolean,
      default: false,
    },
    discountLevel: {
      type: String,
      default: "transaction",
    },
    relatedId: {
      type: Number,
      default: 0,
    },
     purpose: {

      type: String,
      default: null,
    },

    visitId: {
      type: Number,
      default: 0,
    },

    isEnquiry: {
      type: Boolean,
      default: false,
    },
    isQuotation: {
      type: Boolean,
      default: false,
    },
    isPreventive: {
      type: Boolean,
      default: false,
    },
    isInvoice: {
      type: Boolean,
      default: false,
    },
    relatedType: {
      type: Number,
      default: 0,
    },

    ticketDetail: {
      type: Object,
      default: null,
    },

    isProject: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      db_line_items: [],
      allLineItemsChecked: false,
      discount_type_list: [
        { type: "%", value: "2" },
        { type: "$", value: "1" },
      ],
      sno: 1,
      loading: false,
      transactionDetail: {},
      seleceDialog: false,
      serialNumbers: [],
      serialNumberDialog: false,
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    },

    openSerialDialog(item) {
      this.serialNumbers = item?.serialized_items;
      this.serialNumberDialog = true;
    },

    getRowTotal(row) {

    const qty = Number(row.quantity) || 0;
    const rate = Number(row.rate) || 0;
    let total = qty * rate;

    const discountValue = Number(row.discount_value || 0);
    if (discountValue > 0) {
      total -=
        row.discount_type == "2"
          ? (total * discountValue) / 100
          : discountValue;
    }

    return total < 0 ? "0.00" : total.toFixed(2);
  },

    toggleAllLineItems(value) {
      this.db_line_items = this.db_line_items.map((row) => {
        if (row.product_type == "header") {
          return row;
        }

        return {
          ...row,
          is_checked: value,
        };
      });
      this.emitValidationState();
    },

    syncHeaderCheckbox() {
      const selectableRows = this.db_line_items.filter(
        (row) => row.product_type != "header"
      );

      this.allLineItemsChecked =
        selectableRows.length > 0 &&
        selectableRows.every((row) => row.is_checked);
      this.emitValidationState();
    },

    isValidLineItemQuantity(row) {
      const qty = Number(row.quantity);
      const max = Number(row.max_quantity || 0);

      if (!Number.isFinite(qty)) {
        return false;
      }

      return qty >= 1 && qty <= max;
    },

    emitValidationState() {
      const selectedRows = this.visibleLineItems.filter(
        (row) => row.product_type != "header" && row.is_checked
      );

      const isValid =
        selectedRows.length > 0 &&
        selectedRows.every((row) => this.isValidLineItemQuantity(row));

      this.$emit("validation-state", isValid);
    },

    optionSerial(row) {
      this.transactionDetail = row;
      this.seleceDialog = true;
    },
    routeToDetailLink(id, type) {
      this.$router.push({
        name: type,
        params: { id },
      });
    },
    routeToDetail(data) {
      let routeName = null;
      if (data.product_type == "equipment") {
        routeName = "client-equipment.detail";
      } else if (data.product_type == "tools") {
        routeName = "equipment.detail";
      } else if (data.product_type == "asset") {
        routeName = "asset-equipment.detail";
      } else if (data.product_type == "goods") {
        routeName = "product.detail";
      } else if (data.product_type == "service") {
        routeName = "service.detail";
      } else if (data.product_type == "parts") {
        routeName = "part.detail";
      }
      if (data && data.product_id && data.product_id > 0) {
        this.$router.replace(
          this.getDefaultRoute(routeName, {
            params: { id: data.product_id },
          })
        );
      }
    },
    get_line_items() {
      this.loading = true;
      this.$store
        .dispatch(QUERY, {
          url: `detail-iteam/${this.relatedId}/line-items`,
          data: {
            type: this.relatedType,
            visit: this.visitId,
            purpose: this.purpose,
          },
        })
        .then(({ data }) => {
          this.db_line_items = data.map((row) => {
            let original_quantity = row.original_quantity;
            if (original_quantity == null) {
              original_quantity = row.quantity;
            }
            const max_quantity = Math.max(
              Number(original_quantity || 0) - Number(row.used || 0),
              0
            );
            return {
              ...row,
              original_quantity,
              max_quantity,
              quantity: max_quantity,
              is_checked: true,
            };
          });
          this.allLineItemsChecked = true;
          this.$emit("line-item", this.db_line_items.length);
          this.emitValidationState();
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getQuantityRules(row) {
      const max = Number(row.max_quantity || 0);
      return [
        (value) => Number(value) >= 1 || "Quantity must be 1 or greater",
        (value) => Number(value) <= max || `Cannot exceed ${max}`,
      ];
    },
    validateQuantity(row) {
      this.$nextTick(() => {
        const max = Number(row.max_quantity || 0);
        let qty = row.quantity;

        if (qty === "" || qty === null || qty === undefined) {
          this.emitValidationState();
          return;
        }

        qty = Number(qty);
        if (qty > max) {
          row.quantity = max;
        } else if (qty === 0 || qty < 0) {
          row.quantity = 1;
        }
        this.emitValidationState();
      });
    },
    forceValidateQuantity(row) {
      this.$nextTick(() => {
        const max = Number(row.max_quantity || 0);
        let qty = Number(row.quantity);
        if (qty > max) {
          row.quantity = max;
        } else if (qty < 1 || isNaN(qty)) {
          row.quantity = 1;
        }
        this.emitValidationState();
      });
    },
    get_col_style(param, child) {
      let width = 40;
      return { width: child ? `${width - 5}%` : `${width}%` };
    },
  },
  mounted() {
    this.get_line_items();
  },
  watch: {
    db_line_items: {
      handler() {
        this.emitValidationState();
      },
      deep: true,
    },
  },
  computed: {
    visibleLineItems() {
      const visible = [];
      let currentHeader = null;

      const isRowVisible = (row) => {
        if (row.product_type == "header") {
          return false;
        }
        if (Number(row.line_item_used || 0) === 1) {
          return false;
        }
        return true;
      };

      for (const row of this.db_line_items) {
        if (row.product_type == "header") {
          currentHeader = row;
          continue;
        }

        if (Number(row.max_quantity || 0) <= 0) {
          continue;
        }

        if (isRowVisible(row)) {
          if (currentHeader) {
            visible.push(currentHeader);
            currentHeader = null;
          }
          visible.push(row);
        }
      }

      return visible;
    },
    getSN: () => {
      return function (row, index) {
        if (index == 0) {
          this.sno = 1;
          console.log();
        }
        if (row.product_type == "header") {
          this.sno = 1;
        } else {
          this.sno = this.sno + 1;
        }
      };
    },
  },
  components: {
    ViewSerialNumber,
    Dialog,
  },
};
</script>
<style scoped>
.description-text {
  line-height: 1.4;
  display: block;
}
</style>
